export default {
  brands: [],
  models: [],
  recomendations: [],
  services: [],
  dealers: [],
  fetching: {
    loadModels: false,
    loadServices: false,
    loadDealers: false,
    loadRecomendations: false,
  },
  model: null,
  service: null,
};
